export { PDFViewer } from "./pdf-viewer.component";
export type { PDFViewerProps } from "./pdf-viewer.types";
